import React from 'react'
import './Mundu.css'

function Mundu() {
  return (
    <div className="main-mundu-container">
      {/* Hero section with background image and overlay */}
      <div className="mundu-hero">
        <div className="mundu-overlay">
          <h1>MUNDU</h1>
        </div>
      </div>
      
      {/* White gap */}
      <div className="white-gap"></div>
      
      {/* Content section with MUNDU information */}
      <div className="mundu-content">
        <h2>MUNDU Logistics & Network GmbH</h2>
        <p className="mundu-highlight">CENTREX Marine Services is a member of MUNDU Logistics & Network GmbH.</p>
        
        <div className="mundu-section">
          <h3>About MUNDU</h3>
          <p>MUNDU Logistics & Network GmbH is a dynamic, young and high qualitative network for logistics companies from all over the world.</p>
          <p>Equipped with over 20 years of experience in the global logistics industry, we are your perfect contact. It doesn't matter whether you are a young and aspiring company or just want to expand your global business. We support you on your way to further globalize your company.</p>
        </div>
        
        <div className="mundu-section">
          <h3>Our Approach</h3>
          <p>Quality instead of quantity, that's what MUNDU stands for. We support you and your company with passion and personality and thus ensure that you can not only establish new contacts with logisticians from all over the world, but that you can also derive real added value from them.</p>
          <p>No matter if perfectly organized events or a customer service that really deserves this name. We live our network from A to Z. Find out for yourself and become part of a very special family.</p>
        </div>
        
        <div className="mundu-link">
          <a href="https://www.mundu-network.com/en/" target="_blank" rel="noopener noreferrer">
            Visit MUNDU Official Website
          </a>
        </div>
      </div>
    </div>
  )
}

export default Mundu
